export const checkRecaptchaReady = () =>
  new Promise(resolve => window.grecaptcha.ready(resolve));
